/**
 * Общие конфигурации приложения и сборки.
 * Используется в vite.config.ts и при необходимости в коде (через import.meta.env или отдельный импорт).
 */

export const config = {
  /** Порт dev-сервера (npm run dev). */
  devServerPort: 3001,

  /** Папка сборки (npm run build). */
  buildOutDir: 'dist',

  /** Базовый URL API. Dev: бэкенд на другом порту; prod: тот же домен. */
  get apiBaseUrl(): string {
    return typeof import.meta !== 'undefined' && import.meta.env?.DEV
      ? 'http://localhost:3000/api'
      : '/api';
  },

  /** Endpoint для отправки логов (POST, тело: { logs: LogEntry[] }). */
  apiLogsUrl: '/api/logs',
} as const;

export type AppConfig = typeof config;
